import { combineReducers } from "redux";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/wrapperReducer";
import LedgerDetail from "./LedgerDetail";
import LedgerSnapShot from "./LedgerSnapShot";
import snapShotExtention from "./snapShotExtention";
import contractNote from "./ContractNote";
export default combineReducers({
    snapShot: createNamedWrapperReducer(LedgerSnapShot, "snapShot"),
    detail: createNamedWrapperReducer(LedgerDetail, "details"),
    snapShotExtention: createNamedWrapperReducer(snapShotExtention, "snapShotExtention"),
    contractNote: createNamedWrapperReducer(contractNote, "contractNote"),
});
